export default {
    chart: {
        type: 'column',
    },
    yAxis: [{
        title: {
            text: ''
        },
        categories: "",
        labels: {
            format: '{value} MW',
            style: {
                color: '#b0b6c3',
                fontSize: '15px'
            }
        },
        opposite: false
    }],
    plotOptions: {
        series: {
            connectNulls: true,
            pointStart: 2009
        },
        column: {
            colorByPoint: true,
            colors: ['#a487ff', '#b29aff', '#bda8fe', '#8661fb', '#846afb', '#8177fb', '#7e85fa', '#7b93fa', '#78a3fa', '#78b2fa', '#78c8fa', '#76b1f9', '#73bbf9', '#73aff9', '#71c5f9']
        }
    },
    series: [{
        name: function(){
            if(document.documentElement.lang == 'cz'){
                return "Celkový výkon"
            }
            else{
                return "Overall capacity"
            }
            
        }(),
        data: [1.689, 1.689, 2.754, 5.907, 8.272, 12.587, 14.603, 26.948, 69, 82, 86, 86, 94, 116, 127],
        marker: {
            enabled: false
        },
    }],
}

//52


// WEBPACK FOOTER //
// ./data/charts/vykon.js